<section class="terms-item">
    <div class="container">
        <div class="row">
            <div class="col col-md-2"></div>
            <div class="col-12 col-md-10">
                <a name="legal_tad" class="terms-item-link"></a>

                <div>
                    <div class="mb-5 pb-5 d-flex align-items-end">
                        <h2 class="mb-0">Договір</h2>
                        <p class="pl-2">публічної оферти про надання послуг</p>
                    </div>

                    <p>
                        <b>Фізична особа-підприємець Гавриш Роман Орестович, ЄДРПОУ 2955307855</b> (надалі -
                        «Виконавець»), з
                        однієї сторони, пропонує необмеженому колу фізичних осіб (надалі - «Замовник»), з іншої
                        Сторони (надалі разом - «Сторони») – акцептувати цю Публічну оферту (<i>укласти договір про
                        надання
                        послуг</i>).
                    </p>


                    <h3>Розділ 1. Терміни</h3>
                    <p>
                        1.1. Публічна оферта – пропозиція Виконавця (викладена на веб-сайті Виконавця), адресована
                        необмеженому колу фізичних осіб відповідно до статті 641 Цивільного кодексу України укласти
                        Договір про надання послуг на визначених умовах Договору. Оферта є публічною і, згідно ст. ст.
                        633, 641 ЦК України, її умови однакові для всіх Замовників.
                    </p>
                    <p>
                        1.2. Договір – правочин, складений у формі договору приєднання відповідно до ст. 634 Цивільного
                        кодексу України, умови якого встановлені Виконавцем, і який може бути укладено лише шляхом
                        приєднання Замовника до запропонованого Договору в цілому.
                    </p>
                    <p>
                        1.3. Cайт Виконавця (Платформа) – веб-сторінка в мережі Інтернет, за адресою <a
                            href="https://ua.anima.help/" target="_blank">https://ua.anima.help/</a>, яка є основним
                        джерелом інформування Замовника та може бути використана Замовником для замовлення послуг
                        Виконавця.
                    </p>
                    <p>
                        1.4. Послуги – сукупність інформаційних матеріалів та AI-консультацій, що носять
                        інформаційно-роз'яснювальний характер, надаються під час сесій тестування, реалізуються шляхом
                        надання доступу до онлайн-сервісу Anima, та використовуються для надання інформації про стан
                        особи, яка використовує платформу. Повний перелік послуг, їх вартість та детальна інформація
                        щодо них викладені на Сайті Виконавця, за адресою <a href="https://ua.anima.help/#plans"
                                                                             target="_blank">https://ua.anima.help/</a>.
                    </p>
                    <p>
                        1.5. Замовник – будь-яка дієздатна фізична особа, яка Акцептувала Публічну оферту Виконавця,
                        викладену у Договорі.
                    </p>
                    <p>
                        1.6. Акцепт – повне, безумовне та беззастережне прийняття Замовником умов визначених Офертою
                        згідно із частиною 2 статті 642 Цивільного кодексу України, після чого Договір автоматично
                        вважається укладеним. Акцепт може бути здійснений шляхом перерахування грошових коштів на
                        банківський рахунок Виконавця або сервісу платіжної системи за посиланням Виконавця, в якості
                        повної оплати за надання послуг за цим Договором.
                    </p>

                    <h3>
                        Розділ 2. Предмет договору і загальні умови
                    </h3>
                    <p>
                        2.1. Виконавець зобов’язується надати Замовнику передбачені договором Послуги, в строки та на
                        умовах, визначені Договором, а Замовник зобов'язується своєчасно прийняти та оплатити їх.
                    </p>
                    <p>
                        2.2. Послуги, що надає Виконавець в межах цього договору не є медичними, а надана Замовнику
                        інформація не замінює професійну медичну консультацію, діагностику чи лікування.
                    </p>
                    <p>
                        2.3. Замовник надає згоду Виконавцю на використання та обробку його персональних даних в рамках
                        Закону України «Про захист персональних даних».
                    </p>

                    <h3>
                        Розділ 3. Порядок укладення Договору
                    </h3>

                    <p>
                        3.1. Укладання Договору проводиться шляхом повного і беззастережного прийняття (акцептування)
                        Замовником умов Договору. Замовник здійснює акцепт Договору шляхом натискання кнопок “Купити”
                        та “Передплатити” на сторінці сайту <a href="https://ua.anima.help/#plans">https://ua.anima.help/</a>,
                        та оплати обраної Замовником Послуги.
                    </p>
                    <p>
                        3.2. Замовник підтверджує, що до укладення Договору він був повністю та належним чином
                        ознайомлений з усіма його положеннями та прийняв їх.
                    </p>
                    <p>
                        3.3. Договір, за умови дотримання порядку його акцептування, вважається укладеним в письмовій
                        формі, вступає в силу з моменту акцепту і діє протягом усього терміну отримання Послуг, або до
                        моменту його розірвання на підставах, визначених умовами Договору та/або нормами чинного
                        законодавства України.
                    </p>

                    <h3>
                        Розділ 4. Права та обов`язки сторін
                    </h3>

                    <p>
                        4.1. Виконавець зобов’язаний:
                    </p>
                    <ul>
                        <li> 4.1.1. Надати Замовнику своєчасно, якісно та в повному обсязі Послуги відповідно до умов
                            Договору, а також усю необхідну інформацію, пов’язану з наданням таких Послуг.
                        </li>
                        <li>4.1.2. Повідомляти Замовника про настання будь-яких обставин, що унеможливлюють надання
                            Послуг.
                        </li>

                    </ul>
                    <p>
                        4.2. Виконавець має право:
                    </p>

                    <ul>
                        <li>
                            4.2.1. На своєчасну та повну оплату наданих Послуг відповідно до умов Договору.
                        </li>
                        <li>
                            4.2.2. Змінювати вартість та (або) порядок надання Послуг, повідомивши Замовника про такі
                            зміни
                            шляхом розміщення інформації на Сайті.
                        </li>
                        <li>
                            4.2.3. Припинити в односторонньому порядку надання послуг Замовнику (зокрема, але не
                            виключно) у
                            разі наявності заборгованості Замовника перед Виконавцем за надані послуги.
                        </li>
                        <li>
                            4.2.4. Змінити, призупинити, або припинити роботу Платформи, будь-якої частини Платформи або
                            використання Платформи, як для всіх клієнтів, так і для окремого Замовника у випадках,
                            передбачених Договором.
                        </li>
                        <li>
                            4.2.5. Надсилати Замовнику сповіщення або інші повідомлення щодо договору або будь-якого
                            аспекту
                            Платформи електронною поштою на зареєстровану адресу електронної пошти Замовника, звичайною
                            поштою або шляхом розміщення в Інтернеті.
                        </li>
                    </ul>
                    <p>
                        4.3. Замовник зобов’язаний:
                    </p>
                    <ul>
                        <li>
                            4.3.1. Прийняти та оплатити надані Виконавцем послуги у заздалегідь обумовлені Виконавцем
                            строки.
                        </li>
                        <li>
                            4.3.2. Надавати усю необхідну інформацію про себе Виконавцю, що необхідна для надання
                            останнім
                            Послуг за договором.
                        </li>
                        <li>
                            4.3.3. Замовник підтверджує та погоджується, що вся інформація, яку він надав на Платформі
                            або
                            через неї, а також інформація, яку він надасть на Платформі чи через неї в майбутньому, є
                            точною, правдивою, актуальною та повною. Замовник погоджується, що протягом дії цього
                            Договору
                            він буде підтримувати та оновлювати цю інформацію, щоб вона залишалася точною, актуальною та
                            повною.
                        </li>
                        <li>
                            4.3.4. Замовник погоджується, підтверджує та визнає, що несе відповідальність за збереження
                            конфіденційності свого пароля та будь-якої іншої інформації безпеки, пов’язаної з його
                            обліковим
                            записом.
                        </li>
                        <li>
                            4.3.5. Замовник погоджується негайно повідомити Виконавця про будь-яке несанкціоноване
                            використання доступу до його облікового запису.
                        </li>
                        <li>
                            4.3.6. Замовник погоджується, підтверджує та визнає, що Виконавець не несе відповідальності
                            за
                            будь-які втрати чи збитки, заподіяні кимось іншим, хто користується обліковим записом
                            Замовника,
                            з його згодою та/або без відома.
                        </li>
                        <li>
                            4.3.7. Замовник визнає та погоджується з тим, що Виконавець буде вважати його відповідальним
                            за
                            будь-які збитки або втрати, спричинені використанням доступу до облікового запису Замовника
                            будь-якою особою, уповноваженою ним чи ні, і погоджується відшкодувати Виконавцю будь-яку
                            таку
                            шкоду або втрату.
                        </li>
                        <li>
                            4.3.8. Замовник погоджується і зобов’язується не використовувати обліковий запис або доступ
                            до
                            облікового запису іншої особи з будь-якої причини.
                        </li>
                        <li>
                            4.3.9. Замовник погоджується та зобов’язується не втручатися чи порушувати роботу будь-якої
                            з
                            систем, служб, серверів, мереж чи інфраструктури Виконавця або Платформи, а також не
                            намагатися
                            втручатися чи порушувати їх роботу, включаючи отримання несанкціонованого доступу до них.
                        </li>
                    </ul>
                    <p>
                        4.4. Замовник має право:
                    </p>
                    <ul>
                        <li>
                            4.4.1. Вимагати від Виконавця своєчасного та якісного надання послуг за цим Договором.
                        </li>
                    </ul>


                    <h3>
                        Розділ 5. Оплата та порядок отримання Послуг
                    </h3>
                    <p>
                        5.1. Оплата послуг Виконавця здійснюється на умовах повної попередньої оплати у порядку,
                        передбаченому пунктом 3.1. Договору. Ціна Послуг зазначається на Сайті Виконавця за посиланням
                        <a href="https://ua.anima.help/#plans" target="_blank">https://ua.anima.help/</a> і
                        залежить від виду послуги та її тривалості.
                    </p>
                    <p>
                        5.2. У разі, якщо оплата здійснюється за допомогою платіжних систем і сервісів, Замовник
                        перенаправляється на сайт платіжного сервісу. В цьому випадку оплата додатково регулюється
                        правилами платіжного сервісу, банку (в тому числі банку емітента картки Замовника) та інших
                        учасників платежів. Виконавець не здійснює обробку операцій по банківським карткам. У разі
                        помилок або відмов в оплаті Замовник має звернутися до банка-емітента картки або до представника
                        платіжної системи, через яку здійснювалась оплата.
                    </p>
                    <p>
                        5.3. Замовник самостійно несе відповідальність за надання помилкових даних, що спричинило
                        неможливість належного виконання Виконавцем своїх зобов'язань перед Замовником.
                    </p>
                    <p>
                        5.4. Ціна Послуги не містить в собі комісію і додаткові збори банків та платіжних систем.
                        Замовник самостійно і своїм коштом сплачує такі збори. Розмір комісії або додаткового збору
                        повідомляє відповідний банк та платіжна система.
                    </p>
                    <p>
                        5.5. Сторони погоджуються, що невикористання інформації, отриманої під час споживання Послуги з
                        боку Замовника не є підставою для відмови від Договору та підставою для повернення коштів за
                        надану частину Послуг. З
                    </p>
                    <p>
                        5.6. Замовник визнає, що оскільки відповідні Послуги являють собою сесії тестування та
                        інформаційні матеріали, їх якість та повнота презюмується та приймається Замовником без
                        заперечень. Інформація, до якої можна отримати доступ в процесі споживання Послуги, може не
                        охоплювати всі психічні ресурси, захворювання та/або стани, а також їх лікування, а також
                        надається «Як є» і без гарантій, явних чи неявних, включаючи, але не обмежуючись, будь-якими
                        непрямими гарантіями придатності для певної мети.
                    </p>
                    <p>
                        5.7. Після оплати послуг Виконавця Замовник отримає доступ до переліку сервісів, у формі сесій
                        тестування та інформаційних матеріалів у формі рекомендацій та облікового запису.
                    </p>
                    <p>
                        5.8. Доступ до таких сервісів та матеріалів може бути обмежений періодом, зазначеним на сайті
                        Виконавця та залежить від обраного виду Послуги.
                    </p>
                    <p>
                        5.9. Повернення коштів можливе до початку споживання Послуги. Замовник до початку споживання
                        Послуги має право відмовитися від її отримання. В такому випадку сплачені Замовником, будуть
                        повернені. Для реалізаціı̈ права на повернення коштів Замовник має направити відповідне
                        повідомлення Виконавцю на зазначену електронну адресу
                        <a href="mailto:support@anima.help">support@anima.help</a>.
                    </p>

                    <h3>
                        Розділ 6. Відповідальність сторін
                    </h3>
                    <p>
                        6.1. Сторони несуть відповідальність за невиконання чи неналежне виконання зобов'язань за цим
                        Договором відповідно до чинного законодавства України, з урахуванням особливостей,
                        встановлених Договором.
                    </p>
                    <p>
                        6.2. Сторона не несе відповідальності за порушення Договору, якщо воно сталося не з її вини
                        (умислу чи необережності). Сторона вважається невинуватою і не несе відповідальності за
                        порушення Договору, якщо вона доведе, що вжила всіх залежних від неї заходів щодо належного
                        виконання цього Договору.
                    </p>
                    <p>
                        6.3. Сторони звільняються від відповідальності за невиконання або неналежне виконання
                        зобов’язань за цим Договором у разі виникнення обставин непереборної сили, які не існували під
                        час укладання Договору та виникли поза волею Сторін. Такими обставинами є: стихійні лиха,
                        екстремальні погодні умови, пожежі, епідемії, будь-які військові дії, катастрофи, аварії,
                        страйки, забороняючі акти органів держаної влади тощо.
                    </p>
                    <h3>
                        Розділ 7. Інтелектуальна власність
                    </h3>
                    <p>
                        7.1. Виконавець володіє винятковими правами на об’єкти права інтелектуальної власності, доступ
                        до яких матиме Замовник в рамках виконання даного Договору. Будь-яке отримання доступу
                        Замовником за цим Договором до сервісів Виконавця, не призводить до передачі Замовнику будь-яких
                        прав інтелектуальної власності на них.
                    </p>
                    <p>
                        7.2. Оплативши Послуги за цим Договором Замовник:
                    </p>
                    <ul>
                        <li>
                            1) отримує тимчасовий доступ до матеріалів, авторські та суміжні права на які належать
                            Виконавцю;
                        </li>
                        <li>
                            2) впродовж строку, погодженого з Виконавцем Замовник має право користуватися сервісами в
                            межах оплаченої Послуги у власних некомерційних цілях. Матеріали можуть бути використані
                            наступними способами: ознайомлення, перегляд, прочитання, відтворення виключно в особистих
                            цілях. Комерційне використання таких матеріалів, їх копіювання, переробка, повне або
                            часткове використання, публічне відтворення або розповсюдження матеріалів без письмового
                            дозволу Виконавця забороняється.
                        </li>
                    </ul>
                    <p>
                        7.3. У разі виявлення будь-яких інших порушень прав інтелектуальної власності Виконавець має
                        право вимагати від Замовника повного відшкодування збитків, заподіяних таким порушенням.
                    </p>
                    <p>
                        7.4. Будь-яка частина Платформи не може бути скопійована, відтворена, повторно опублікована,
                        завантажена, розміщена, відображена, передана або розповсюджена.
                    </p>

                    <h3>
                        Розділ 8. Інші умови
                    </h3>

                    <p>
                        8.1. Порядок врегулювання спорів та застосовне право.
                    </p>
                    <ul>
                        <li>
                            8.1.1. Всі суперечки та спори, що можуть виникнути в процесі надання послуг Виконавцем, у
                            зв’язку з прийняттям, виконанням та/або порушенням положень цього Договору та всіх додатків
                            до нього, врегульовуються шляхом переговорів Сторін.
                        </li>
                        <li>
                            8.1.2. В разі недосягнення згоди шляхом переговорів, Замовник залишає за собою право на
                            пред’явлення претензій, які обов’язково повинні бути розглянуті Виконавцем в розумні
                            строки, з метою врегулювання суперечок та спорів в досудовому порядку.
                        </li>
                        <li>
                            8.1.3. В разі недосягнення згоди між Сторонами, шляхом переговорів та неможливості
                            врегулювання в досудовому порядку, всі спори та суперечки вирішуються в судовому порядку за
                            місцезнаходженням Виконавця.
                        </li>
                        <li>
                            8.1.4. До відносин сторін, що випливають з прийняття та виконання даного Договору ,
                            застосовуються чинні норми та положення законодавства України.
                        </li>
                    </ul>
                    <p>
                        8.2. Обмеження відповідальності Виконавця.
                    </p>
                    <ul>
                        <li>8.2.1. Сторони розуміють і визнають, що невідповідність результату надання тієї чи іншої
                            Послуги
                            результату, що очікував та бажав отримати Замовник при зверненні за наданням відповідної
                            Послуги,
                            саме по собі не є фактом неналежної якості наданої Послуги.
                        </li>
                    </ul>
                    <p>
                        8.3. Прикінцеві положення.
                    </p>
                    <ul>
                        <li>
                            8.3.1. Виконавець залишає за собою право в будь-який час в односторонньому порядку вносити
                            зміни до даного Договору.
                        </li>
                        <li>
                            8.3.2. Всі зміни до цього Договору публікуються на Сайті Виконавця.
                        </li>
                        <li>
                            8.3.3. Всі зміни до даного Договору набувають чинності з моменту їх публікації на Сайті
                            Виконавця.
                        </li>
                        <li>
                            8.3.4. Внесені зміни, що набрали чинності, розповсюджуються на всіх Замовників.
                        </li>
                        <li>
                            8.3.5. Замовники вважаються повідомленими про внесені до Договору зміни з моменту
                            опублікування цих змін на Сайті Виконавця.
                        </li>
                        <li>
                            8.3.6. Після розміщення дійсного Договору Публічної оферти на сайті Виконавця всі
                            попередні погодження, які вступають з ним в протиріччя, втрачають силу.
                        </li>
                        <li>
                            8.3.7. Контактні дані Виконавця: Київ 04050, Україна. Миколи Пимоненка вул., 13ж, 3-й
                            поверх, <a href="mailto:support@anima.help">support@anima.help</a> та <a
                                href="mailto:cooperation@anima.help">cooperation@anima.help</a>.
                        </li>
                    </ul>
                    <p class="text-muted mt-4">Редакція станом на 18.07.2024</p>

                </div>

                <!--                to-->
                <a name="legal_pp" class="terms-item-link"></a>
                <h2>Політика конфіденційності </h2>

                <h3>1. Про вашу конфіденційність і цю Політику конфіденційності</h3>

                <p>Ваша конфіденційність надзвичайно важлива для нас. Ми постійно докладаємо багато зусиль,
                    інструментів, ресурсів і процедур, щоб захистити вашу конфіденційність. Цей документ є нашою
                    «Політикою конфіденційності», і він містить детальну інформацію про проблеми, пов’язані з вашою
                    конфіденційністю під час використання наших послуг. Ця Політика конфіденційності поширюється на
                    відвідувачів загальнодоступних веб-сайтів, якими володіє та керує Anima, зареєстрованих користувачів
                    веб-додатку Anima (разом із веб-сайтами, «Платформа»). Він призначений для інформування вас про нашу
                    політику, процедури та практику щодо збору, використання та розкриття будь-якої інформації, яку ви
                    надаєте через Платформу. Якщо ви є нинішнім або колишнім претендентом на роботу Anima, працівником,
                    власником, директором, посадовою особою чи підрядником, зв’яжіться з нами за адресою
                    questions@anima.help. Ваші права відповідно до законів про конфіденційність, які діють у вашій
                    юрисдикції, представлені в додатку до цієї політики. Якщо ви не бачите цього додатку нижче,
                    зв’яжіться з нами за адресою questions@anima.help, щоб отримати додаткову інформацію з описом ваших
                    прав відповідно до цих законів. Політика конфіденційності є частиною наших Умов використання.
                    Терміни в Політиці конфіденційності (такі як, але не виключно, «ми», «наш», «нас», «Платформа» та
                    «Послуги консультантів») мають те саме значення, що й у нашому документі «Загальні положення та
                    умови». Коли ви користуєтеся нашою платформою, ви приймаєте та погоджуєтеся як з Умовами
                    використання, так і з Політикою конфіденційності. Якщо ви не згодні дотримуватися Політики
                    конфіденційності, вам слід негайно припинити використання Платформи. Отримавши доступ і
                    використовуючи нашу Платформу, ви підтверджуєте, що прочитали Умови використання та Політику
                    конфіденційності та розумієте, погоджуєтесь і визнати всі умови, що містяться в них обох.</p>

                <h3>2. Збір, використання та розкриття інформації.</h3>

                <h3>Категорії зібраної інформації. </h3>

                <p>Щоб дозволити нам ефективно керувати Платформою та дозволити вам користуватися Платформою, ми можемо
                    збирати, використовувати та зберігати інформацію, описану нижче. Ми також розкриваємо певну
                    інформацію третім сторонам, як описано нижче. Інформація, яку ми збираємо, отримується прямо чи
                    опосередковано від вас і генерується під час використання вами Платформи. Дані, які ми збираємо, не
                    використовуються для маркетингових чи будь-яких інших цілей, за винятком випадків, визначених цією
                    Політикою конфіденційності. </p>

                <p><b>Дані відвідувачів:</b> Anima збирає, використовує та зберігає дані щодо відвідувань користувачами
                    її веб-сайту та використання програми Anima («Дані відвідувачів»), включаючи конкретні сторінки, які
                    відвідав або переглянув користувач, кількість часу, який користувач витратив на веб-сайт або
                    додаток, помилки веб-сайту, з якими стикається користувач, відвідування сторінки «FAQ» Anima, а
                    також інформацію про браузер або пристрій, який використовується для доступу до веб-сайту та
                    програми, наприклад, ідентифікатор мобільного пристрою користувача та IP-адресу.</p>

                <p><b>Дані реєстрації: </b>на додаток до відповідей на анкету, наданих користувачами під час початкової
                    реєстрації, Anima збирає, використовує та зберігає певні додаткові дані від користувачів під час
                    процесу реєстрації («Дані реєстрації»). Ці дані включають сторінки, які переглядає користувач, чи
                    натискає користувач посилання «Почати», щоб розпочати тест. </p>

                <p><b>Реєстраційні дані облікового запису:</b> Anima збирає, використовує та зберігає певну інформацію у
                    зв’язку з процесом реєстрації облікового запису, наприклад, чи зареєстровані користувачі за
                    допомогою профілем Facebook або Google, а також те, чи підтверджує користувач свою адресу
                    електронної пошти чи номер телефону («Реєстраційні дані облікового запису»). Anima також призначає
                    кожному користувачеві, який створює обліковий запис Anima, анонімний, послідовно згенерований
                    ідентифікатор клієнта.</p>

                <p><b>Дані транзакцій:</b> Anima збирає, використовує та зберігає певну інформацію щодо оплати своїх
                    послуг користувачами та пов’язаних транзакцій на своєму веб-сайті, наприклад, чи здійснив користувач
                    оплату послуг Animas, зареєструвався на послуги Anima за допомогою пробної пропозиції, скасував чи
                    іншим чином закінчив пробну версію або завершив запит на отримання фінансової допомоги для послуг
                    Anima («Дані транзакції»).
                </p>

                <p><b>Дані для входу:</b> Anima збирає, використовує та зберігає дані щодо входу на платформу Anima
                    зареєстрованими користувачами та активності під час цього входу, наприклад, коли користувач входить,
                    кількість повідомлень, отриманих або надісланих через веб-сайт або додаток Anima під час цього
                    входу, а також те, чи було призначено, розпочато чи виконано користувачем. Дані для входу не
                    включають вміст будь-яких повідомлень, надісланих або отриманих користувачами, або вміст будь-яких
                    цілей консультування.</p>

                <p><b>Дані клієнта:</b> Anima збирає, використовує та зберігає певні дані від користувачів, які
                    зареєструвалися на послуги Anima, такі як ім’я або псевдонім, вік, адресу електронної пошти, номер
                    телефону та контактну інформацію для екстрених випадків («Дані клієнта»).</p>

                <p><b>Комунікаційні дан:</b> Anima збирає, використовує та зберігає комунікаційні дані між користувачами
                    та фахівцями на Платформі, а також комунікації між користувачами та командою обслуговування клієнтів
                    Anima («Комунікаційні дані»). Захист цієї інформації важливий для нас. Окрім способів, описаних у
                    цій Політиці конфіденційності, ми ніколи не використовуватимемо та не розголошуватимемо жодної
                    інформації, якщо ви не попросите або не схвалите це.
                    Цілі, для яких використовується інформація: ми можемо використовувати зібрану інформацію для однієї
                    або кількох із наведених нижче цілей:
                </p>

                <h3>Спілкування з вами</h3>

                <ul>
                    <li>Щоб зв’язатися з вами або надати вам інформацію, сповіщення та пропозиції, пов’язані з
                        Платформою.
                    </li>
                    <li>Щоб підтвердити вашу особу.</li>
                    <li>Для завершення дії, яку ви запитували, наприклад, реєстрації на Платформі або отримання
                        додаткової інформації.
                    </li>
                    <li>Щоб зв’язатися з вами, самостійно або за допомогою відповідних органів, якщо ми маємо вагомі
                        підстави вважати, що ви чи будь-яка інша особа можете опинитися в небезпеці або можете бути
                        причиною або жертвою злочинного діяння.
                    </li>
                </ul>

                <h3>Надання вам послуг</h3>

                <ul>
                    <li>Щоб створити свій обліковий запис на нашій Платформі та дозволити вам увійти у свій обліковий
                        запис і використовувати Платформу.

                    </li>
                    <li>Щоб керувати вашим обліковим записом, надавати вам підтримку клієнтів і гарантувати, що ви
                        отримуєте якісне обслуговування.
                    </li>
                    <li>Для виставлення рахунків і обробки транзакцій.
                    </li>
                    <li>Для забезпечення, підтримки, персоналізації та розвитку нашої Платформи.</li>
                </ul>

                <h3>Адміністрування та вдосконалення послуг</h3>

                <ul>
                    <li>Для нагляду, адміністрування та моніторингу Платформи.</li>
                    <li>Вимірювати та покращувати якість, ефективність і надання наших послуг.</li>
                </ul>

                <h3>Налаштування</h3>

                <ul>
                    <li>Щоб персоналізувати досвід веб-сайту та надавати вміст, а також пропозиції продуктів і послуг,
                        що відповідають індивідуальним інтересам, включаючи цільові пропозиції та рекламу.
                    </li>
                </ul>

                <h3>Відповідність закону</h3>

                <ul>
                    <li>Щоб відповідати на запити правоохоронних органів і відповідно до чинного законодавства, ухвали
                        суду чи державних постанов.
                    </li>
                    <li>Для дотримання відповідних державних і федеральних законів, включаючи, але не обмежуючись
                        законами, пов’язаними із захистом здоров’я та безпеки клієнтів і населення.
                    </li>
                    <li>Дозволити терапевтам відповідати ліцензійним, юридичним вимогам і вимогам щодо якості в їхніх
                        юрисдикціях.
                    </li>
                </ul>

                <h3>Інше використання за згодою</h3>

                <ul>
                    <li>Будь-які інші цілі за вашою згодою.</li>
                </ul>

                <h3>Цілі, з якими інформація розкривається третім особам.</h3>

                <p>Інформація про вас може бути розголошена третім сторонам з однією або декількома з наведених нижче
                    цілей:</p>

                <p><strong>Для комерційних цілей:</strong> ми можемо надавати вашу інформацію постачальникам послуг,
                    включаючи наш хостинг даних і дані партнери зі зберігання, аналітикам, що надають технологічні
                    послуги та підтримку, обробку платежів і безпеку даних. Ми також можемо ділитися інформацією з
                    професійними радниками, такими як аудитори, юридичні та бухгалтерські компанії. За вашою вказівкою
                    чи згодою: ми можемо надати вашу інформацію третім сторонам, якщо ви попросите або дасте нам наказ
                    про це. З афілійованими особами в межах нашої корпоративної групи: ми можемо надати вашу інформацію
                    будь-яким дочірнім або материнським компаніям у нашій корпоративній групі.</p>


                <p><strong>Для реклами:</strong>якщо ви погоджуєтеся на використання цільових файлів cookie та
                    веб-маяків, інформація про вашу діяльність на наших веб-сайтах, за винятком активності, коли ви
                    ввійшли в систему та розпочали терапію, може бути розкрита нашим рекламним партнерам для оптимізації
                    маркетингу. Ми не надаємо жодній рекламній платформі особисту інформацію, як імена учасників, адреси
                    електронної пошти, номери телефонів, діагнози, дані сеансів, записи, повідомлення, чи будь-який
                    інший тип спілкування, який ви маєте зі своїм терапевтом.
                </p>
                <p>Якщо ви хочете відмовитися від цих файлів cookie та веб-маяків</p>

                <p><b>Відповідність закону:</b> ми можемо надати вашу інформацію суду, регулюючому органу, працівникам
                    правоохоронних органів або відповідно до повістки в суд для дотримання чинного законодавства або
                    будь-яких зобов’язань за ним. </p>

                <p><strong>У контексті транзакції:</strong> ми можемо надати вашу інформацію у зв’язку з продажем
                    активів, злиттям, банкрутством або іншою бізнес-операцією.</p>

                <p>З інших ділових причин: ми можемо надати вашу інформацію для забезпечення виконання будь-яких
                    застосовних Умов і положень і Умов використання, а також для забезпечення безпеки Платформи та наших
                    користувачів. Зауважте, що якщо ви робите будь-яку інформацію загальнодоступною на Платформі,
                    будь-хто може бачити та використовувати таку інформацію.
                </p>

                <h3>3. Відмова від маркетингових повідомлень </h3>

                <p>Ви можете відмовитися від отримання маркетингових повідомлень електронною поштою, скасувавши підписку
                    за посиланням для скасування підписки, наданим у всіх наших маркетингових повідомленнях електронною
                    поштою.</p>

                <a name="cookies" class=""></a>
                <h3>4. Файли cookie та веб-маяки</h3>

                <p>Як і багато веб-сайтів, ми використовуємо файли cookie та веб-маяки (також відомі як пікселі) для
                    збору інформації. "Cookie" - це невеликий файл даних, який передається на жорсткий диск вашого
                    комп'ютера з метою зберігання даних. Ми збираємо файли cookie, які необхідні для функціонування
                    Платформи, файли cookie, які підвищують продуктивність Платформи, і файли cookie, які
                    використовуються для відстеження третьою стороною. «Веб-маяк» — це крихітне та іноді невидиме
                    зображення або вбудований код, розміщений на веб-сторінці чи електронному листі, який може
                    повідомляти третій стороні про ваш візит або використання. Веб-маяки зазвичай використовуються
                    третіми сторонами для моніторингу активності користувачів на веб-сайті з метою веб-аналітики,
                    оптимізації реклами або позначення сторінок. Додаткову інформацію про веб-маяки можна знайти у
                    Вікіпедії. Ви можете змінити налаштування свого браузера, щоб він припинив приймати файли cookie та
                    веб-маяки або щоб запитувати вас перед прийняттям файлів cookie чи веб-маяка. Використання файлів
                    cookie, веб-маяків і подібних технологій для аналітики. Ми можемо використовувати сторонні файли
                    cookie або веб-маяки для цілей веб-аналітики, атрибуції та керування помилками. Наша Платформа може
                    використовувати служби постачальників, які використовують файли cookie, веб-маяки та подібні
                    технології, щоб збирати та зберігати анонімну інформацію про вас, зокрема, коли ви оплачуєте
                    послуги, завантажуєте сторінку, вказуєте, що ви чули про нас, підписуєтеся на послуги, введіть свою
                    платіжну інформацію (але деталі платежу не розголошуються), почніть заповнювати анкету та свою
                    відповідь щодо джерела направлення на Платформу. </p>

                <p>Наша Платформа також використовує постачальників аналітичних засобів для збору інформації (наприклад,
                    даних про відвідувачів і даних реєстрації) про дії користувачів на наших веб-сайтах з метою
                    аналітики та аналізу певного використання Платформи. Використання файлів cookie, веб-маяків і
                    подібних технологій для рекламних мереж. Якщо ви погодитеся на використання цільових файлів cookie
                    та веб-маяків, ви та інші можете бачити певні оголошення наших послуг або Платформи на інших
                    веб-сайтах, оскільки ми беремо участь у рекламних мережах. Рекламні мережі дозволяють нам націлювати
                    наші повідомлення на користувачів за допомогою демографічних, на основі інтересів і контекстуальних
                    засобів. Ці мережі відстежують онлайн-діяльність людей протягом тривалого часу, збираючи інформацію
                    за допомогою автоматизованих засобів, зокрема за допомогою файлів cookie, журналів веб-сервера та
                    веб-маяків. Мережі використовують цю інформацію для показу реклами, яка може бути адаптована до
                    інтересів особи. Інформація, яку можуть збирати наші рекламні мережі, включає інформацію про ваші
                    відвідування веб-сайтів, які беруть участь у відповідних рекламних мережах, як сторінки чи рекламні
                    оголошення, які ви переглядаєте, і дії, які ви виконуєте на веб-сайтах. Цей збір даних відбувається
                    як на наших веб-сайтах, так і на веб-сайтах третіх осіб, які беруть участь у рекламних мережах. Цей
                    процес також допомагає нам відстежувати ефективність наших маркетингових зусиль і допомагає іншим
                    веб-сайтам і рекламним партнерам знайти вас або таких же людей на різних платформах, у тому числі на
                    веб-сайтах соціальних мереж.</p>

                <p>
                    Інструменти соціальної та загальної інформації. Ми використовуємо декілька загальнодоступних
                    інструментів і ресурсів обміну інформацією, таких як (але не обмежуючись ними) блог і Facebook (?).
                    Будь-яка інформація, яку ви надаєте або ділитеся під час використання Інструментів соціальної та
                    загальної інформації, може бути прочитана, доступна, зібрана цим сайтом і користувачами цього сайту
                    відповідно до Політики конфіденційності.
                </p>

                <h3>6. Фішинг</h3>

                <p>Крадіжка особистих даних і злом облікових записів в Інтернеті, включно з практикою, яка зараз відома
                    як «фішинг», викликають велике занепокоєння. Ви завжди повинні бути уважними, коли вас просять
                    надати інформацію вашого облікового запису, і ви завжди повинні переконатися, що ви робите це в
                    нашій безпечній системі. Ми ніколи не запитуватимемо вашу реєстраційну інформацію або дані вашої
                    кредитної картки в будь-якому незахищеному або небажаному повідомленні (електронною поштою,
                    телефоном чи іншим способом).</p>

                <h3>7. Безпека інформації</h3>

                <p>Ми вживаємо комерційно обґрунтовані заходи для захисту цілісності та конфіденційності особистої
                    інформації про здоров’я, якою ви можете поділитися з нами. Майте на увазі, що жодні заходи безпеки
                    не є досконалими чи непроникними, і ми не можемо гарантувати абсолютну безпеку вашої інформації. Ми
                    докладемо всіх зусиль, щоб захистити вашу інформацію, але ви також повинні захистити свої дані. Крім
                    того, ми не контролюємо дії будь-кого, з ким ви або будь-який інший користувач Anima можете
                    поділитися інформацією. Таким чином, ви повинні бути обережними щодо доступу, який ви надаєте іншим
                    під час використання Anima, і даних, які ви вирішуєте надати під час використання Anima.</p>

                <h3>8. Постачальники послуг</h3>

                <p>Ми можемо наймати сторонні компанії та осіб для сприяння роботі нашої Платформи, виконання певних
                    завдань, пов’язаних із Платформою, або для надання аудиторських, юридичних, операційних чи інших
                    послуг для нас. Ці завдання включають, але не обмежуються ними, обслуговування клієнтів, технічне
                    обслуговування, моніторинг, керування електронною поштою та зв’язок, керування базами даних,
                    виставлення рахунків і обробку платежів, звітність і аналітику. Ми будемо ділитися з ними лише
                    мінімально необхідною інформацією для виконання своїх завдань за нас і лише після укладення
                    відповідної угоди про конфіденційність.
                    Ми можемо надавати (або треті сторони можуть надавати) посилання на сторонні веб-сайти, служби або
                    ресурси поза нашим контролем. Ми не робимо заяв або схвалень щодо якості, придатності,
                    функціональності чи законності будь-якого стороннього вмісту, на який можуть надаватися посилання.
                    Цим ви відмовляєтеся від будь-яких претензій, які ви можете мати проти нас щодо таких послуг. ANIMA
                    НЕ НЕСЕ ВІДПОВІДАЛЬНОСТІ ЗА ВМІСТ В ІНТЕРНЕТІ АБО ВЕБ-СТОРІНКАХ, РОЗТАШОВАНИХ ЗА МЕЖАМИ ПЛАТФОРМИ.
                </p>

                <p>Ваші ділові відносини з третіми сторонами, виявлені на або через Платформу, включаючи оплату та
                    будь-які інші положення, умови, гарантії чи заяви, пов’язані з такими операціями, здійснюються
                    виключно між вами та такою третьою стороною. Ви погоджуєтеся з тим, що ми не несемо відповідальності
                    за будь-які втрати чи збитки, спричинені такими транзакціями, присутністю такої третьої сторони або
                    посиланнями на сторонні веб-сайти чи ресурси на Платформі.</p>

                <h3>9. Дотримання законів і правоохоронна діяльність. </h3>

                <p>Ми співпрацюємо з державними та правоохоронними органами для забезпечення виконання та дотримання
                    закону. Ми можемо розкривати інформацію, необхідну або відповідну для захисту громадської безпеки чи
                    будь-якої особи, для відповіді на претензії та судові процеси (включаючи, але не обмежуючись,
                    повістки до суду), а також для запобігання чи припинення діяльності, яка може бути незаконною чи
                    небезпечною. Ви також повинні знати, що наші спеціалісти можуть бути зобов’язані розкрити інформацію
                    правоохоронним або іншим органам для виконання своїх професійних і юридичних обов’язків. Зокрема,
                    але не обмежуючись, ви повинні знати, що закон вимагає від спеціалістів із психічного здоров’я
                    розкривати інформацію та/або вживати заходів у таких випадках: (a) повідомлення про жорстоке
                    поводження з дитиною чи вразливою дорослою особою або підозра на нього; (б) серйозний суїцидальний
                    потенціал; (в) загроза заподіяння шкоди іншій особі; (г) призначення лікування за рішенням суду.</p>

                <h3>10. Зміни в Політиці конфіденційності</h3>

                <p>Ми можемо оновлювати цю заяву про конфіденційність на власний розсуд. Дата останнього перегляду цієї
                    політики вказана в кінці цієї сторінки. Ми рекомендуємо вам періодично переглядати цю сторінку, щоб
                    отримати найновішу інформацію про нашу політику конфіденційності та практику. Незалежно від змін у
                    нашій Політиці конфіденційності, ми ніколи не використовуватимемо інформацію, яку ви надаєте згідно
                    з нашим поточним повідомленням про конфіденційність, у новий спосіб без попереднього сповіщення вас
                    і надання вам можливості припинити використання Платформи.</p>

                <h3>11. Безпека</h3>
                <p>Ми вживаємо комерційно обґрунтованих заходів для захисту цілісності та конфіденційності
                    ідентифікаційної інформації та інформації про здоров’я, якою ви можете поділитися з нами. Майте на
                    увазі, що жодні заходи безпеки не є досконалими або непроникними, і ми не можемо гарантувати
                    абсолютну безпеку вашої інформації. Ми зробимо свій внесок у захист вашої інформації, але вам також
                    важливо захистити свою інформацію. Крім того, ми не контролюємо дії будь-кого, з ким ви або
                    будь-який інший користувач Anima можете поділитися інформацією. Таким чином, ви повинні бути
                    обережними щодо доступу, який ви надаєте іншим під час використання Anima, та інформації, яку ви
                    вирішуєте надати під час використання Anima.</p>
                <h3>11. Зв’язок з нами.</h3>

                <p>Якщо у вас виникли запитання чи сумніви щодо цієї Політики конфіденційності або наших заходів,
                    пов’язаних із конфіденційністю, будь ласка, зв’яжіться з нами questions@anima.help. Якщо ви хочете
                    співпрацювати з нами, зв’яжіться з нами за адресою cooperation@anima.help.</p>

                <a name="legal_npp" class="terms-item-link"></a>
                <h2>Практика конфіденційності</h2>

                <p>и можемо збирати такі види інформації, коли ви використовуєте Послуги:</p>

                <p>Інформація, яку ви надаєте безпосередньо нам. Ми гарантуємо безпеку вашої інформації Для певних дій,
                    наприклад, коли ви реєструєтеся, користуєтеся нашими телемедичними послугами, підписуєтеся на наші
                    сповіщення або звертаєтесь до нас напряму, ми можемо збирати деякі або всі такі типи інформації:</p>

                <ul>
                    <li>Контактна інформація, така як ваше повне ім’я, адреса електронної пошти, номер мобільного
                        телефону;
                    </li>
                    <li>Ім'я користувача та пароль;</li>
                    <li>платіжну інформацію, таку як номер вашої кредитної картки, термін дії та код безпеки кредитної
                        картки;
                    </li>
                    <li>Інформація про особисте здоров'я;</li>
                    <li>Будь-яка інша інформація, яку ви нам надаєте.</li>
                </ul>

                <p>Ми можемо поєднати таку інформацію з інформацією про вас, яку ми вже маємо.
                    Інформація, яку ми збираємо автоматично. Ми можемо автоматично збирати певну інформацію, коли ви
                    користуєтеся нашими Послугами, наприклад адресу вашого Інтернет-протоколу (IP), ідентифікатори
                    пристрою та реклами, тип браузера, операційну систему, постачальника послуг Інтернету, сторінки, які
                    ви відвідуєте до та після використання Послуг, дату і час вашого відвідування, інформацію про
                    посилання, які ви натискаєте, і сторінки, які ви переглядаєте в межах Послуг, а також іншу
                    стандартну інформацію сервера. Ми також можемо збирати певну інформацію про місцезнаходження, коли
                    ви користуєтеся нашими Послугами, наприклад IP-адресу вашого комп’ютера, сигнал GPS вашого
                    мобільного пристрою або інформацію про найближчі точки доступу WiFi і вежі стільникового зв’язку.
                </p>
                <p>Ми можемо використовувати файли cookie, теги пікселів, локальні спільні об’єкти та подібні технології
                    для автоматичного збору цієї інформації. Використовуючи послуги, ви погоджуєтесь на використання
                    файлів cookie та подібних технологій.</p>
                <p>Ми також можемо збирати технічні дані для вирішення та усунення технічних проблем і покращення наших
                    Послуг, включаючи стан пам’яті вашого пристрою, коли під час користування нашими Послугами
                    відбувається збій системи або програми. Налаштування вашого пристрою або браузера може дозволити вам
                    контролювати збір цих технічних даних. Ці дані можуть містити частини документа, який ви
                    використовували, коли виникла проблема, або вміст ваших повідомлень. Використовуючи Послуги, ви
                    погоджуєтеся на збір цих технічних даних.</p>
                <p></p>

                <p>Цілями обробки отриманих від Вас персональних даних є:</p>

                <ul>
                    <li>адміністрування Сервісу;</li>
                    <li>персоналізація сайту, що дозволяють отримувати Послуги в Сервісі;</li>
                    <li>направлення рахунків, нагадувань, повідомлень та повідомлень щодо Послуг, які є предметом
                        Договору
                    </li>
                    <li>розгляд запитів та скарг, зроблених Вами щодо роботи Сервісу;
                    </li>
                    <li>надсилання повідомлень електронною поштою, за здійсненими Вами запитами;</li>
                    <li>оцінка якості надання послуг;</li>
                    <li>оцінка використання різних функцій Сервісу;
                    </li>
                    <li>підвищення функціональності Сервісу та якості надання послуг;</li>
                    <li>визначення аудиторії Сервісу та статистики використання послуг, що надаються з використанням
                        Сервісу;
                    </li>
                    <li>забезпечення безпеки Сервісу та запобігання шахрайству;</li>
                    <li>статистичні та наукові цілі.</li>
                </ul>

                <p>Крім того, надані Вами дані можуть використовуватися адміністрацією з маркетинговою метою відповідно
                    до чинного законодавства України. При використанні даних користувача для прямого маркетингу
                    (комерційне розсилання та маркетингові повідомлення про нові послуги та пропозиції, які можуть бути
                    цікаві Користувачам), включається посилання, перейшовши яким користувач може відмовитися від
                    отримання таких повідомлень у майбутньому.</p>

                <h3>Використання інформації</h3>
                <p>
                    Зазвичай ми використовуємо інформацію, яку збираємо в Інтернеті, щоб:
                </p>
                <ul>
                    <li>Надавати та вдосконалювати Послуги;</li>
                    <li>Зв'язатися з вами;</li>
                    <li>Виконувати ваші запити на продукти, послуги та інформацію;
                    </li>
                    <li>Надсилати вам інформацію про додаткові клінічні послуги чи загальне оздоровлення від нас або від
                        імені наших афілійованих осіб і довірених сторонніх партнерів;
                    </li>
                    <li>Аналіз використання Сервісів і даних користувачів для розуміння та вдосконалення Сервісів;</li>
                    <li>Проводити дослідження з використанням вашої інформації, що може потребувати вашого окремого
                        письмового дозволу;
                    </li>
                    <li>Запобігаання потенційно забороненій або незаконній діяльності та іншим чином відповідно до наших
                        Умов використання
                    </li>
                    <li>Для будь-яких інших цілей, розкритих вам під час збору вашої інформації або за вашою згодою.
                    </li>
                </ul>
                <h3>Обмін інформацією</h3>

                <p>Ми прагнемо зберегти вашу довіру та хочемо, щоб ви розуміли, коли та з ким ми можемо ділитися
                    інформацією, яку збираємо.</p>

                <ul>
                    <li>Постачальники медичних послуг, страхові компанії та інші організації, пов’язані з охороною
                        здоров’я. Ми можемо ділитися вашою інформацією з іншими постачальниками медичних послуг,
                        лабораторіями, державними установами, страховими компаніями, організаціями, що займаються
                        закупівлею органів, судово-медичними експертами чи похоронними організаціями, а також іншими
                        організаціями, які пропонують варіанти лікування та підтримку.
                    </li>
                    <li>Авторизовані сторонні продавці та постачальники послуг. Ми можемо передавати вашу інформацію
                        стороннім постачальникам і постачальникам послуг, які допомагають нам із спеціалізованими
                        послугами, зокрема виставленням рахунків, обробкою платежів, обслуговуванням клієнтів,
                        розгортанням електронної пошти, бізнес-аналітикою, маркетингом (включаючи, але не обмежуючись
                        рекламою, атрибуцією, мобільним маркетингом, оптимізацією і ретаргетинг), моніторинг
                        продуктивності, хостинг і обробка даних. Ці сторонні постачальники та постачальники послуг не
                        можуть використовувати вашу інформацію для інших цілей, окрім тих, що пов’язані з послугами, які
                        вони нам надають.
                    </li>
                    <li>Партнери з дослідження. Ми можемо ділитися вашою інформацією з нашими дослідницькими партнерами
                        для проведення досліджень, пов’язаних зі здоров’ям; такий обмін може залежати від вашого
                        письмового дозволу.
                    </li>
                    <li>Корпоративні філії. Відповідно до цієї політики ми можемо ділитися вашою інформацією з нашими
                        корпоративними філіями.
                    </li>
                    <li>Перекази бізнесу. Ми можемо надати вашу інформацію у зв’язку зі значною корпоративною
                        транзакцією, такою як продаж веб-сайту, злиття, консолідація, продаж активів або у
                        малоймовірному випадку банкрутства.
                    </li>
                    <li>Правові цілі. Ми можемо розкривати інформацію у відповідь на повістки до суду, ухвали суду,
                        судові процеси, запити правоохоронних органів, судові претензії чи державні запити, а також для
                        захисту та захисту прав, інтересів, здоров’я, безпеки та безпеки American Well, наших філій,
                        користувачів , або громадськість. Припустімо, що ми за законом зобов’язані розкрити інформацію
                        про вас третій стороні. У такому випадку ми спробуємо повідомити вас, надіславши електронний
                        лист на електронну адресу, зазначену в наших записах, якщо це не порушить закон або ви не надали
                        нам свою електронну адресу.
                    </li>
                    <li>З вашої згоди або за вашим вказівкою. Ми можемо ділитися інформацією для будь-яких інших цілей,
                        розкритих вам під час збору інформації або за вашою згодою чи вказівкою.
                    </li>
                </ul>

                <p>За межами випадків використання, зазначених вище, ми не будемо надавати вашу інформацію третім
                    особам. Однак сторонні служби доступу, такі як Facebook або Google, через Послуги для входу в
                    Послуги або для обміну інформацією про ваш досвід користування Послугами з іншими. Ці сторонні
                    служби можуть збирати інформацію про вас, у тому числі інформацію про вашу діяльність на Сайті. Вони
                    можуть сповіщати ваші зв’язки зі сторонніми службами про використання вашого сайту відповідно до
                    своєї політики конфіденційності.</p>

                <p>Якщо ви берете участь у публічній діяльності на Сайті або сторонніх сайтах, на які ми посилаємося, ви
                    повинні знати, що будь-яка інформація, яку ви надаєте там, може бути прочитана, зібрана або
                    використана іншими користувачами цих областей. Важливо бути обережним, розкриваючи особисту
                    інформацію під час участі на цих сайтах. Ми не несемо відповідальності за дані, які ви вирішите
                    надати в цих загальнодоступних місцях.</p>

                <h3>Безпека</h3>

                <p>Ми використовуємо розумні заходи, щоб допомогти захистити інформацію від втрати, крадіжки,
                    неправильного використання та несанкціонованого доступу, розголошення, зміни та знищення. Ви повинні
                    розуміти, що жодна система зберігання даних або передача даних через Інтернет чи будь-яку іншу
                    загальнодоступну мережу не може гарантувати 100-відсоткову безпеку. Зверніть увагу, що інформація,
                    зібрана третіми сторонами, може не мати такого захисту, як інформація, яку ви нам надсилаєте, і ми
                    не несемо відповідальності за захист такої інформації.</p>

                <a name="legal_nnd" class="terms-item-link"></a>
                <h2>Недискримінація</h2>

                <p>Anima не дискримінує та не допускає дискримінації, включаючи, без обмеження, знущання, жорстоке
                    поводження чи переслідування, на основі фактичної чи передбачуваної раси, кольору шкіри, релігії,
                    національного походження, походження, віку, статі, фізичних або розумових вад, сексуальної
                    орієнтації , гендерної ідентичності, самовираження чи ВІЛ-статусу, або на основі зв’язку з іншою
                    особою через фактичну або передбачувану расу, колір шкіри, релігію, національне походження,
                    походження, вік, стать, фізичні чи розумові вади, сексуальну орієнтацію, гендерну ідентичність або
                    ВІЛ-статус.</p>

                <p>Дата набрання чинності 21 серпеня 2022</p>

            </div>
        </div>
    </div>
</section>
<app-footer></app-footer>
